// extracted by mini-css-extract-plugin
export default {"container":"AmountSummary_container__KOtF6","field":"AmountSummary_field__ka3ol","value":"AmountSummary_value__JxQa8","totalAmount":"AmountSummary_totalAmount__BiCuY"};